import { render, staticRenderFns } from "./generateCertComponent.vue?vue&type=template&id=8a892360&"
import script from "./generateCertComponent.vue?vue&type=script&lang=ts&"
export * from "./generateCertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports